<div class="main-container">
  <!-- Header Section -->
  <div class="page-header">
    <div class="routing-buttons">
      <div
        class="action-button back-button"
        (click)="navigateBack()"
        tabindex="0"
        (keydown.enter)="navigateBack()"
      >
        <mat-icon class="icon back-icon">arrow_back</mat-icon>
      </div>
      <div
        class="action-button reload-button"
        (click)="ngOnInit()"
        tabindex="0"
        (keydown.enter)="ngOnInit()"
      >
        <mat-icon class="icon reload-icon">refresh</mat-icon>
      </div>
      <span class="page-title"> Manual FOTA </span>
    </div>
    <div class="button-group">
      <app-fota-info></app-fota-info>
    </div>
  </div>

  <form [formGroup]="deviceFOTAForm" novalidate>
    <div class="component-container">
      <div class="component-header">
        <h6 class="component-title">Search Device</h6>
      </div>
      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>
      <!-- Component Body Section -->
      <div class="component-body">
        <div class="form-section">
          <div class="form-group">
            <label for="imei" class="form-label">IMEI</label>
            <mat-form-field appearance="outline">
              <mat-label>IMEI</mat-label>
              <input
                matInput
                formControlName="imei"
                placeholder="IMEI"
                required
              />
              @if (
                deviceFOTAForm.controls['imei'].touched &&
                deviceFOTAForm.controls['imei'].errors?.requiredAndNoEmptySpaces
              ) {
                <mat-error>
                  {{
                    deviceFOTAForm.controls['imei'].errors
                      ?.requiredAndNoEmptySpaces
                  }}
                </mat-error>
              }
              @if (
                deviceFOTAForm.controls['imei'].touched &&
                deviceFOTAForm.controls['imei'].errors?.exactLengthValidator
              ) {
                <mat-error>
                  {{
                    deviceFOTAForm.controls['imei'].errors?.exactLengthValidator
                  }}
                </mat-error>
              }
              @if (
                deviceFOTAForm.controls['imei'].touched &&
                deviceFOTAForm.controls['imei'].errors?.numericValidator
              ) {
                <mat-error>
                  {{ deviceFOTAForm.controls['imei'].errors?.numericValidator }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      </div>
      <!-- Component Footer Section -->
      <div class="component-footer">
        <div class="button-group">
          <button
            type="button"
            class="submit-button"
            [disabled]="deviceFOTAForm.get('imei')?.invalid"
            (click)="onSearch(deviceFOTAForm?.get('imei')?.value)"
          >
            Search <mat-icon class="btn-icon">edit</mat-icon>
          </button>
          @if (isSearched && createManualFota) {
            <button
              type="button"
              class="submit-button"
              [disabled]="deviceFOTAForm.get('imei')?.invalid"
              (click)="setManualFota()"
            >
              Manual FOTA <mat-icon class="btn-icon">add</mat-icon>
            </button>
          }
        </div>
      </div>
    </div>

    @if (manualFotaToggle) {
      <div class="component-container">
        <div class="component-header">
          <h6 class="component-title">Device Firmware Details</h6>
        </div>
        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>
        <!-- Component Body Section -->
        <div class="component-body">
          <div class="form-section">
            <div class="form-group">
              <label for="imei" class="form-label">IMEI</label>
              <mat-form-field appearance="outline">
                <mat-label>IMEI</mat-label>
                <input
                  matInput
                  formControlName="imei"
                  placeholder="IMEI"
                  readonly
                />
              </mat-form-field>
            </div>

            <div class="form-group">
              <label for="uin" class="form-label">UIN</label>
              <mat-form-field appearance="outline">
                <mat-label>UIN</mat-label>
                <input
                  matInput
                  formControlName="uin"
                  placeholder="UIN"
                  readonly
                />
              </mat-form-field>
            </div>

            <div class="form-group">
              <label for="assignedState" class="form-label"
                >Assigned State</label
              >
              <mat-form-field appearance="outline">
                <mat-label>Assigned State</mat-label>
                <input
                  matInput
                  formControlName="assignedState"
                  placeholder="Assigned State"
                  readonly
                />
              </mat-form-field>
            </div>

            <div class="form-group">
              <label for="currentFirmwareVersion" class="form-label"
                >Current Firmware Version</label
              >
              <mat-form-field appearance="outline">
                <mat-label>Current Firmware Version</mat-label>
                <input
                  matInput
                  formControlName="currentFirmwareVersion"
                  placeholder="Current Firmware Version"
                  readonly
                />
              </mat-form-field>
            </div>

            <div class="form-group">
              <label for="lastFOTAInitiatedFor" class="form-label"
                >Last FOTA Initiated For</label
              >
              <mat-form-field appearance="outline">
                <mat-label>Last FOTA Initiated For</mat-label>
                <input
                  matInput
                  formControlName="lastFOTAInitiatedFor"
                  placeholder="Last FOTA Initiated For"
                  readonly
                />
              </mat-form-field>
            </div>

            <div class="form-group">
              <label for="ais140" class="form-label">FOTA Type</label>
              <mat-form-field appearance="outline">
                <mat-label>FOTA Type</mat-label>
                <mat-select formControlName="ais140">
                  <mat-option [value]="true">AIS140 FOTA</mat-option>
                  <mat-option [value]="false">Regular FOTA</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- Is FOTA Mandatory -->
            <div class="form-group">
              <label for="isFotaMandatory" class="form-label"
                >Is FOTA Mandatory</label
              >
              <mat-form-field appearance="outline">
                <mat-label>Is FOTA Mandatory</mat-label>
                <mat-select formControlName="isFotaMandatory">
                  <mat-option [value]="false"> No </mat-option>
                  <mat-option [value]="true"> Yes </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="form-group">
              <label for="stateItem" class="form-label">State</label>
              <mat-form-field appearance="outline">
                <mat-label>State</mat-label>
                <mat-select formControlName="stateItem">
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="stateNameFilterCtrl"
                      [noEntriesFoundLabel]="'No options found'"
                      placeholderLabel="Filter"
                    >
                    </ngx-mat-select-search>
                  </mat-option>
                  @for (item of filteredStateName; track item) {
                    <mat-option [value]="item">
                      {{ item.state }} ({{ item.stateAbbreviation }})
                    </mat-option>
                  }
                </mat-select>
                @if (
                  deviceFOTAForm.get('stateItem')?.touched &&
                  deviceFOTAForm.get('stateItem')?.invalid
                ) {
                  <mat-error>State is required</mat-error>
                }
              </mat-form-field>
            </div>

            <div class="form-group">
              <label for="UFWItem" class="form-label"
                >Targeted Firmware Version</label
              >
              <mat-form-field appearance="outline">
                <mat-label>Targeted Firmware Version</mat-label>
                <mat-select formControlName="UFWItem">
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="ufwNameFilterCtrl"
                      [noEntriesFoundLabel]="'No options found'"
                      placeholderLabel="Filter"
                    >
                    </ngx-mat-select-search>
                  </mat-option>
                  @for (fw of filteredFirmwareList; track fw) {
                    <mat-option [value]="fw">
                      {{ fw.firmwareVersion }} ({{ fw.fileName }})
                    </mat-option>
                  }
                </mat-select>
                @if (
                  deviceFOTAForm.get('UFWItem')?.touched &&
                  deviceFOTAForm.get('UFWItem')?.invalid
                ) {
                  <mat-error>Firmware is required</mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </div>
        <!-- Component Footer Section -->
        <div class="component-footer">
          <div class="button-group">
            <button
              type="button"
              class="submit-button"
              [disabled]="!isFirmwareDetailsFormValid()"
              (click)="submitManualFota()"
            >
              Create Manual FOTA <mat-icon class="btn-icon">add</mat-icon>
            </button>
          </div>
        </div>
      </div>
    }
  </form>

  @if (isSearched) {
    <div class="component-container">
      <div class="component-header">
        <h6 class="component-title">Device FOTA History List</h6>
        <div class="component-actions">
          <button
            type="button"
            class="primary-button"
            (click)="exportToExcel()"
            [disabled]="listOfBatch.length === 0"
          >
            Download<mat-icon class="btn-icon">download</mat-icon>
          </button>
          <!-- <app-common-search
            [initialSearchValue]="deviceFOTAForm?.get('batchListSearch')?.value"
            [placeHolder]="'Search by IMEI and Press Enter'"
            (searchSubmit)="onSearch($event)"
          ></app-common-search> -->
        </div>
      </div>

      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>

      <!-- Component Body Section -->
      <div class="component-body">
        <table>
          <thead>
            <tr>
              <th>Batch ID</th>
              <th>Created At</th>
              <th>FOTA Type</th>
              <th>Is Mand.</th>
              <th>IMEI</th>
              <th>State</th>
              <th>AF</th>
              <th>UFW</th>
              <th>Last Login</th>
              <!-- <th>Added To Batch</th> -->
              <th>D/L%</th>
              <th>FOTA Status</th>
              <!-- <th>Download Duration</th> -->
              <th>1st SEO Status</th>
              <th>1st IP Status</th>
              <th>2nd IP Status</th>
              <th>2nd SEO Status</th>
              <th>3rd IP Status</th>
              <th>4th IP Status</th>
              <th>Updated At</th>
              @if (deleteManualFota || deleteFotaBatch) {
                <th>Action</th>
              }
            </tr>
          </thead>
          @if (listOfBatch.length !== 0) {
            <tbody>
              @for (
                fotaDeviceDetail of listOfBatch
                  | paginate
                    : {
                        id: 'paginate',
                        itemsPerPage: size,
                        currentPage: page,
                        totalItems: totalLength,
                      };
                track fotaDeviceDetail
              ) {
                <tr
                  [ngClass]="{
                    'red-row': fotaDeviceDetail.isAborted,
                    'green-row':
                      fotaDeviceDetail.deviceFotaCompletionStatus === true &&
                      fotaDeviceDetail.deviceFotaStatus === 'Completed' &&
                      fotaDeviceDetail.isAborted !== true,
                    'blue-row':
                      fotaDeviceDetail.deviceFotaCompletionStatus === true &&
                      fotaDeviceDetail.deviceFotaStatus === 'Skipped' &&
                      fotaDeviceDetail.isAborted !== true,
                  }"
                  [matTooltip]="
                    fotaDeviceDetail.isAborted
                      ? fotaDeviceDetail.abortReason || 'Aborted'
                      : ''
                  "
                >
                  <td>
                    {{ fotaDeviceDetail.batchId?.batchId || '--' }}
                  </td>
                  <td>
                    {{
                      fotaDeviceDetail.createdBy
                        ? fotaDeviceDetail.createdBy.firstName +
                          ' ' +
                          fotaDeviceDetail.createdBy.lastName
                        : '--'
                    }}
                    <br />
                    {{
                      fotaDeviceDetail.createdAt
                        ? (fotaDeviceDetail.createdAt
                          | date: 'dd MMM yyyy | hh:mm:ss a')
                        : '--'
                    }}
                  </td>
                  <td>
                    {{ fotaDeviceDetail.ais140 ? 'AIS 140' : 'Regular' }}
                  </td>
                  <td>
                    {{ fotaDeviceDetail.isFotaMandatory ? 'Yes' : 'No' }}
                  </td>
                  <td>
                    {{ fotaDeviceDetail.imei }}
                  </td>
                  <td>
                    {{ fotaDeviceDetail.state }}
                  </td>
                  <td>
                    {{
                      fotaDeviceDetail.currentFirmwareVersion
                        ? fotaDeviceDetail.currentFirmwareVersion
                        : '--'
                    }}
                  </td>
                  <td>
                    {{ fotaDeviceDetail.targetFirmwareVersion }}
                  </td>
                  <td>
                    {{
                      fotaDeviceDetail.lastDevicePing
                        ? (fotaDeviceDetail.lastDevicePing
                          | date: 'dd-MMM-yyyy hh:mm:ss a')
                        : '--'
                    }}
                    <app-info-tooltip
                      block
                      heading="Login Ping Count"
                      [description]="getPingCountTooltip(fotaDeviceDetail)"
                    ></app-info-tooltip>
                  </td>
                  <!-- <td>
                    {{ fotaDeviceDetail.addedToBatch ? 'Yes' : 'No' }}
                  </td> -->
                  <td>
                    {{ fotaDeviceDetail.progress }} %
                    <app-info-tooltip
                      block
                      heading="Download Duration Breakup"
                      [description]="downloadDurationTooltip(fotaDeviceDetail)"
                    ></app-info-tooltip>
                  </td>
                  <td>
                    {{ fotaDeviceDetail.deviceFotaStatus }}
                    <app-info-tooltip
                      block
                      heading="FOTA Attempt Count"
                      [description]="getRetryCountTooltip(fotaDeviceDetail)"
                    ></app-info-tooltip>
                  </td>
                  <!-- <td>
                    {{
                      fotaDeviceDetail.startedAt
                        ? (fotaDeviceDetail.startedAt
                          | date: 'dd-MMM-yyyy hh:mm:ss a')
                        : '--'
                    }}
                    to
                    {{
                      fotaDeviceDetail.completedAt
                        ? (fotaDeviceDetail.completedAt
                          | date: 'dd-MMM-yyyy hh:mm:ss a')
                        : '--'
                    }}
                  </td> -->
                  <td>
                    {{ fotaDeviceDetail.stateEnableSetStatus || '--' }}
                    <app-info-tooltip
                      block
                      heading="1st SEO Details"
                      [description]="get1stSEOTooltip(fotaDeviceDetail)"
                    ></app-info-tooltip>
                  </td>
                  <td>
                    {{ fotaDeviceDetail.govtIp1SetStatus || '--' }}
                    <app-info-tooltip
                      block
                      heading="1st IP Details"
                      [description]="getGovtIp1Tooltip(fotaDeviceDetail)"
                    ></app-info-tooltip>
                  </td>
                  <td>
                    {{ fotaDeviceDetail.govtIp2SetStatus || '--' }}
                    <app-info-tooltip
                      block
                      heading="2nd IP Details"
                      [description]="getGovtIp2Tooltip(fotaDeviceDetail)"
                    ></app-info-tooltip>
                  </td>
                  <td>
                    {{ fotaDeviceDetail.secondaryStateEnableSetStatus || '--' }}
                    <app-info-tooltip
                      block
                      heading="2nd SEO Details"
                      [description]="get2ndSEOTooltip(fotaDeviceDetail)"
                    ></app-info-tooltip>
                  </td>
                  <td>
                    {{ fotaDeviceDetail.govtIp3SetStatus || '--' }}
                    <app-info-tooltip
                      block
                      heading="3rd IP Details"
                      [description]="getGovtIp3Tooltip(fotaDeviceDetail)"
                    ></app-info-tooltip>
                  </td>
                  <td>
                    {{ fotaDeviceDetail.govtIp4SetStatus || '--' }}
                    <app-info-tooltip
                      block
                      heading="4th IP Details"
                      [description]="getGovtIp4Tooltip(fotaDeviceDetail)"
                    ></app-info-tooltip>
                  </td>
                  <td>
                    {{
                      fotaDeviceDetail.updatedAt
                        ? (fotaDeviceDetail.updatedAt
                          | date: 'dd-MMM-yyyy hh:mm:ss a')
                        : '--'
                    }}
                  </td>
                  @if (deleteManualFota || deleteFotaBatch) {
                    <td>
                      <div class="action-buttons">
                        @if (fotaDeviceDetail.batchId) {
                          <button
                            class="primary-button abort-button"
                            type="button"
                            [disabled]="
                              fotaDeviceDetail.deviceFotaCompletionStatus !==
                                false ||
                              !deleteFotaBatch ||
                              fotaDeviceDetail.isAborted !== false
                            "
                            (click)="abort(fotaDeviceDetail._id)"
                          >
                            <mat-icon class="btn-icon">block</mat-icon>
                          </button>
                        }
                        @if (!fotaDeviceDetail.batchId) {
                          <button
                            class="primary-button abort-button"
                            type="button"
                            [disabled]="
                              fotaDeviceDetail.deviceFotaCompletionStatus !==
                                false ||
                              !deleteManualFota ||
                              fotaDeviceDetail.isAborted !== false
                            "
                            (click)="abort(fotaDeviceDetail._id)"
                          >
                            <mat-icon class="btn-icon">block</mat-icon>
                          </button>
                        }
                      </div>
                    </td>
                  }
                </tr>
              }
            </tbody>
          }
          @if (listOfBatch.length === 0) {
            <tbody>
              <tr>
                <td colspan="20">
                  <img
                    class="no-data-img"
                    src="../../assets/dataNotFound.jpg"
                    alt="No Data Found"
                  />
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>
      <!-- Separator between Body and Footer -->
      <div class="component-separator"></div>

      <!-- Component Footer Section -->
      <div class="component-footer">
        @if (listOfBatch.length !== 0) {
          <app-common-component-pagination
            [totalItems]="listOfBatch.length"
            [pageSize]="size"
            [currentPage]="page"
            (pageChange)="onPageChange($event)"
            (sizeChange)="onSizeChange($event)"
          >
          </app-common-component-pagination>
        }
      </div>
    </div>
  }
</div>
